export const defaultSettings = {
  usesThemeStyles: true,
}